<template>
  <div class="app-container">
    <BjRouteTabs :route-list="LOGISTICS_COMPANY_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompanyBusiness.header.name')" prop="name">
            <BjInput
              v-model="queryParams.name"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('businessLogisticsCompanyBusiness.header.name')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompany.table.logisticsCompanyName')" prop="companyId">
            <BjSelectLogisticCompany v-model="queryParams.companyId" :placeholder="$t('businessLogisticsCompany.table.logisticsCompanyName')" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('businessLogisticsCompany.common.status')" prop="enableFlag">
            <BjSelectLov v-model="queryParams.enableFlag" :placeholder="$t('businessLogisticsCompany.common.status')" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <el-tag
                v-else-if="col.prop === 'enableFlag'"
                :type="scope.row[col.prop] ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_TRUE.bjGet(scope.row[col.prop])) }}</el-tag
              >

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!$store.getters.cusId && col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                class="edit-btn"
                @click="onEdit(scope.row)"
                >{{ $t('editText') }}</el-button
              > -->
              <el-button
                v-if="!scope.row.enableFlag"
                type="text"
                @click="onStatus(true, scope.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-else
                type="text"
                @click="onStatus(false, scope.row)"
                >{{ $t('disableText') }}</el-button
              >
              <!-- <el-button
                :disabled="scope.row.status == 1"
                type="text"
                class="delete-btn"
                @click="onDelete(scope.row)"
                >{{ $t('delText') }}</el-button
              > -->
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { logisticApi, channelApi } from '@/api';
import { LOGISTICS_COMPANY_ROUTE_LIST, STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
export default {
  name: 'BusinessLogisticsCompanyBusinessIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      LOGISTICS_COMPANY_ROUTE_LIST,
      STATUS_ENABLED_TRUE,
      queryApi: logisticApi.getLogisticsBusiness,
      // 查询参数
      queryParams: {
        name: null,
        companyId: null,
        enableFlag: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'businessLogisticsCompanyBusiness.table.abbreviation', prop: 'name', isCheck: true, disabled: false, width: 200 },
        { label: 'businessLogisticsCompanyBusiness.table.full', prop: 'logisticsName', isCheck: true, disabled: false, width: 200 },
        { label: 'businessLogisticsCompany.table.logisticsCompanyName', prop: 'companyName', isCheck: true, disabled: false, width: 200 },
        { label: 'businessLogisticsCompany.table.status', prop: 'enableFlag', isCheck: true, disabled: false },
        { label: 'businessLogisticsCompany.table.creator', prop: 'createdName', isCheck: true, disabled: false },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 200 },
        { label: 'businessLogisticsCompany.table.action', prop: 'bjTableAction', isCheck: true, disabled: false, width: 100},
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 修改状态 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_TRUE.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            id: row.id,
            enableFlag: flag,
            objectVersionNumber: row.objectVersionNumber,
          }, {
            logisticsCode: row.code,
            logisticsStatus: flag
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      // logisticApi.detailLogisticsBusiness({ id: row.id }).then(res => {
      //   this.$refs.DataForm.show(this.$lodash.clone(res));
      // });
      console.log(row);
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },

    operationApi(API_DATA, API_DATA2) {
      logisticApi.updateLogisticsBusiness(API_DATA).then(res => {
        if (!res.failed) {
          channelApi.updateByLogisticsCodeLogisticsStatus(API_DATA2).then(res2 => {
            if (!res2.failed) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
              }
          });
        }
      });
    },
    // deleteApi(API_DATA) {
    //   logisticApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    batchDeleteApi(API_DATA) {
      logisticApi.deleteLogisticsBusiness(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
